module.exports = __webpack_public_path__ + "img/financial-sale.b6b5f312.png";